<template>
    <x-data-table
        class="no-row-hover"
        :headers="headers"
        :items="items"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No data found</p>
        </template>
        <template v-slot:items="props">
            <tr>
                <td>
                    {{ props.item.name ?? 'N/A' }}
                </td>
                <td>
                    {{ props.item.address?.fullAddress ?? 'N/A' }}
                </td>
            </tr>
        </template>
    </x-data-table>
</template>

<script>
export default {
    name: 'MSTNameAddressTable',
    props: {
        headers: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">

</style>
